import "../css/bookclosure.css";
import {Button} from "../elements/Button";
import commoncss from "../css/common.module.css"
import buttoncss from "../css/button.module.css"
import BookClosureTable from "../elements/BookClosureTable";
import { ReactComponent as FilterIcon } from "../assets/icons/filter.svg";
import Breadcrumb from "../components/Breadcrumb";

const FscpPostings = () => {

    const breadcrumbItems = [
        {
          label: "Workspace name",
          link: "/myfinv2/book-closure",
          className: `${commoncss.nav_cnt_color} clickable`,
        },
        {
          label: "Book closure name",
          link: "/myfinv2/",
          className: `${commoncss.nav_cnt_color} clickable`,
        },
        { label: "View FSCP Posting", link: "", className: "headerLable" },
    ];

    // const tableHeaders = {
    //     sno: "S no",
    //     ledgercode: "Ledger code",
    //     ledgername: "Ledger name",
    //     amount: "Amount",
    //     assignee: "Assignee",
    //     approver: "Approver",
    //     removeEventListeneremarks: "Remarks",
    //     module: "Module"
    // };

    // const rowData = [
    //     {
    //         sno: "11",
    //         ledgercode: "145",
    //         ledgername: "Other non-financial assets",
    //         amount: "Amount",
    //         assignee: "Assignee",
    //         approver: "Approver",
    //         removeEventListeneremarks: "Remarks",
    //         module: "Module"
    //     },
        
    // ];

    return(
        <div className="import-presets-wrapper bgClr1">
            <div className="fscp-header">
                <Breadcrumb style="margin-right:auto"
                    addCls={"bgClr1"}
                    items={breadcrumbItems}
                    headerActions={<></>}
                />
                <FilterIcon width={20} height={20}/>
                <Button
                    btnColor={buttoncss.secondary}
                    label="View Matrix"
                />
                <Button
                    btnColor={buttoncss.primary}
                    label="Export to Excel"
                />
            </div>

            {/* <BookClosureTable tableHeaders={tableHeaders} rowData={rowData} columnClasses={columnClasses} headerClasses={headerClasses}/> */}

        </div>
    )
}

export default FscpPostings;